import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { openComponentModal } from '../../../PageBuilder/helpers/modal';
import { ActionLink } from '../result-block-styled-components';

const IFrame = styled.iframe`
  width: calc(100% + 32px);
  margin-top: 40px;
  margin-left: -16px;

  @media (min-width: 768px) {
    width: 100%:
    margin-left: 0;
  }
`;

const BottomTitle = styled.div`
  p {
    margin: 12px 0;
    font-family: 'OCRoboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-transform: uppercase;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 16px;
    }
  }

  h3 {
    font-family: 'Oswald';
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;

    @media (max-width: 768px) {
      font-size: 22px;
      line-height: 24px;
    }
  }
`;

const VirtualTour = ({ url, label, isModal = true, name, buyType }) => {
  const onClick = () => {
    openComponentModal(() => (
      <div>
        <IFrame
          src={url}
          title={`Virtual Showroom for ${name}`}
          width="100%"
          height={600}
          allowFullScreen
          allow="xr-spatial-tracking"
          frameBorder="0"
        />
        <BottomTitle>
          <p>Virtual Showroom</p>
          <h3>{name}</h3>
        </BottomTitle>
      </div>
    ));
  };

  return (
    <ActionLink
      onClick={isModal ? onClick : null}
      href={isModal ? undefined : url}
      target="_blank"
      rel="noopener"
      tabIndex={0}
      data-track="virtual-tour"
      data-track-buy-type={buyType}
    >
      {label}
    </ActionLink>
  );
};

VirtualTour.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
  buyType: PropTypes.string,
};

VirtualTour.defaultProps = {
  isModal: true,
  buyType: null,
};

export default VirtualTour;
